module.exports = __webpack_public_path__ + "static/media/trx-logo.eca821c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo/trx-logo.png
// module id = 1044
// module chunks = 0